import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TextareaField from './TextareaField';

const TextareaFieldAdapter = ({ input, meta, className, ...rest }) => {
  const touched = meta && meta.touched;
  const error = meta && meta.error;
  const errorMessage = touched && error;
  const textareaWrapperClassNames = classNames(
    {
      'has-error': errorMessage,
    },
    className
  );

  return <TextareaField {...input} {...rest} className={textareaWrapperClassNames} />;
};
TextareaFieldAdapter.propTypes = {
  input: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool.isRequired,
    error: PropTypes.string,
  }),
  className: PropTypes.string,
};
export default TextareaFieldAdapter;
